<template>
  <div>
    <div v-show="!banner.title" class="fixed h-screen w-full bg-white bg-opacity-80 z-50 flex justify-center items-center"> 
      <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-theme-sky"></div>
    </div>
    <banner :banner="banner"/>

    <div class="section">
      <VueperSlides
        class="no-shadow mx-20 pb-10 hidden md:block"
        :visible-slides="4"
        :bullets="true"
        slide-multiple
        bullets-outside
        :gap="3"
        :slide-ratio="1 / 3"
        :dragging-distance="70"
        :breakpoints="{ 800: { visibleSlides: 1, slideMultiple: 2, slideRatio: 2/1.2, arrows:false},
                        1281:{ visibleSlides: 3, slideRatio: 2/5 },
                        1400:{ visibleSlides: 3, slideRatio: 1/3 },  }">

          <VueperSlide v-for="(slide, i) in slides" :key="i" >
              <template #content>
                  <div class="vueperslide__content-wrapper bg-theme-fa rounded-xl px-5 flex flex-col justify-evenly shadow-lg align-left items-start">
                      <h4 class="md:text-xl xl:text-3xl text-theme-blue font-bold">{{slide.name}}</h4>
                      <dl class="my-5">
                          <dt class="text-theme-sky mt-5 font-light flex">
                              <Icons name="marker" class="h-6 w-6 stroke-current" />Ubicación</dt>
                              <dl class="md:font-normal md:text-base
                                         xl:font-semibold xl:text-xl text-left">{{slide.address}}</dl>
    
                          <div v-if="slide.email">
                            <dt class="text-theme-sky mt-5 font-light flex">
                                <Icons name="envelope" class="h-6 w-6 stroke-current" />Email</dt>
                                <dl class="md:font-normal md:text-base
                                           xl:font-semibold text-left">{{slide.email}}</dl>
                          </div>
                          <div v-else>
                            <dt class="text-theme-sky mt-5 font-light flex">
                                <Icons name="phone" class="h-6 w-6 stroke-current" />Teléfono</dt>
                                <dl class="md:font-normal md:text-base
                                           xl:font-semibold text-left">{{slide.phone}}</dl>
                          </div>

                      </dl>
                      <div class="mx-auto">
                          <div class="btn-readmore text-white bg-theme-blue m-auto rounded-lg text-center 
                                      py-2 px-3
                                      xl:py-4 xl:px-6 
                                      md:py-2 md:px-4
                                      text-sm">
                              <router-link :to="{name:'BiblioDetail', params: {id:slide.id}}">MÁS INFORMACIÓN</router-link>
                          </div>
                      </div>                    
                  </div>
              </template>          
          </VueperSlide>
        </VueperSlides>

        <div class="md:hidden relative ml-6">
          <div class="md:max-w-screen-md  lg:max-w-screen-lg xl:max-w-screen-xl 2xl:max-w-screen-2xl 
                      mx-auto min-w-0 h-fullr">
            <div class="overflow-x-auto flex">
             
              <div  v-for="slide in slides" :key="slide.id" class="py-6 px-4 first:pl-6 last:pr-6 flex">
                <!-- <div class="grow flex flex-col items-center justify-center gap-3"> -->
                  <div class="w-64 rounded-md bg-theme-fa shadow flex flex-col items-center justify-between text-center py-4">
                      <h4 class="md:text-xl xl:text-3xl text-theme-blue font-bold mb-12 pt-2">{{slide.name}}</h4>
                      <div class="mx-auto w-10/12">
                          <a :href="`mailto:${slide.email}`" target="_blank" 
                             class="btn-biblios text-theme-blue m-auto rounded text-center flex mb-2
                                      py-3 px-3
                                      xl:py-4 xl:px-6 
                                      md:py-2 md:px-4
                                      text-sm
                                      focus:ring-theme-sky focus:outline-none focus:ring">
                                      <Icons name="envelope" class="h-5 w-5 stroke-current mr-2" /> 
                                      <span>Email</span>
                          </a>
                          <a :href="slide.location" target="_blank" class="btn-biblios text-theme-blue m-auto rounded text-center flex mb-3
                                      py-3 px-3
                                      xl:py-4 xl:px-6 
                                      md:py-2 md:px-4
                                      text-sm
                                      focus:ring-theme-sky focus:outline-none focus:ring">
                                      <Icons name="marker" class="h-5 w-5 stroke-current mr-2" />
                                      <span>Ver Ubicación</span>
                          </a>
                          <div class="btn-readmore text-white bg-theme-blue m-auto rounded text-center
                                      py-2 px-3
                                      xl:py-4 xl:px-6 
                                      md:py-2 md:px-4
                                      text-sm">
                              <router-link :to="{name:'BiblioDetail', params: {id:slide.id}}">MÁS INFORMACIÓN</router-link>
                          </div>
                      </div>                  
                  </div>
                <!-- </div> -->
              </div>
          </div>
        </div>        
      </div>

    </div>
    <authors :autores="autores" /> 

    <librosqc :librosqc="librosqc"/> 

    <links :links="links" /> 

    <contact-form /> 

  </div> 

</template>

<script>

import Banner from '@/components/home/Banner'
import Authors from '@/components/home/Authors'
import Librosqc from '@/components/home/Librosqc'
import Links from '@/components/home/Links'
import ContactForm from '@/components/home/ContactForm'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import Icons from '@/components/Icons.vue'  

export default {
  name: "Home",     
  components: {
    Banner,
    Authors,
    VueperSlides, 
    VueperSlide,
    Librosqc,
    ContactForm,
    Links,
    Icons

  },

  data(){
      return{
        slides: [],
        libraries:"",
        contents:"",
        banner:{},
        autores:{},
        librosqc:{},
        links:{}
      }
  },
  watch:{
    contents: function(){

        this.banner = { 'title':    this.contents.filter(obj => obj.section == 'banner' && obj.element == 'title')[0].content,
                        'subtitle': this.contents.filter(obj => obj.section == 'banner' && obj.element == 'subtitle')[0].content,
                        'pretitle': this.contents.filter(obj => obj.section == 'banner' && obj.element == 'pretitle')[0].content
                      }
        
        this.autores = { 'title':this.contents.filter(obj => obj.section == 'autores' && obj.element == 'title')[0].content,
                         'image':this.contents.filter(obj => obj.section == 'autores' && obj.element == 'image')[0].image
                        }
        
       
        this.librosqc = { 'title':    this.contents.filter(obj => obj.section == 'librosqc' && obj.element == 'title')[0].content,
                          'subtitle': this.contents.filter(obj => obj.section == 'librosqc' && obj.element == 'subtitle')[0].content 
                        }
        this.links    = { 'title': this.contents.filter(obj => obj.section == 'links' && obj.element == 'title')[0].content,
                          'image': this.contents.filter(obj => obj.section == 'links' && obj.element == 'image')[0].image
                        }
    }
  },
  methods: {
    async getLibraries(){
      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/libraries`;
      const response = await fetch(get,{method: 'GET'})
      this.libraries = await response.json()
      this.slides = this.libraries
    },

    async getContent(view){

      var filter = `?view=${view}`
      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/contents${filter}`
      const response = await fetch(get,{method: 'GET'})
      this.contents = await response.json()
      
    }
  },
  created(){
    this.getLibraries()
    this.getContent('home')
  },
  mounted () {
    window.scrollTo(0, 0)
  },   
};
</script>

<style>

  .vueperslides__arrow svg {
      width: 3em !important;
  }

  .vueperslides__arrow {
    color: #142C7B;
  }

</style>
